import { render, staticRenderFns } from "./ThePagination.vue?vue&type=template&id=bf8ed1fc&"
import script from "./ThePagination.vue?vue&type=script&lang=js&"
export * from "./ThePagination.vue?vue&type=script&lang=js&"
import style0 from "./ThePagination.vue?vue&type=style&index=0&id=bf8ed1fc&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports